
import React, { Component } from 'react'
import {  Panel } from "react-bootstrap"
import ReactDataGrid from 'react-data-grid'
import {  videoblue  } from "../../utils/sitecolors"
import ContentWrapper from '../../components/layout/ContentWrapper';


export default class RankingSettings extends Component {
  constructor (props) {
    super(props)

    const width = 40

    // const data = [
    //     {
    //         Schools:3,
    //         Finish:[
    //            {
    //                pos:1,
    //                points:250
    //            },
    //            {
    //             pos:2,
    //             points:80
    //            },
    //            {
    //             pos:3,
    //             points:0
    //            }
    //         ]      
    //     },
    //     {
    //         Schools:4,
    //         Finish:[
    //            {
    //                pos:1,
    //                points:250
    //            },
    //            {
    //             pos:2,
    //             points:115
    //            },
    //            {
    //             pos:3,
    //             points:40
    //            },
    //            {
    //             pos:4,
    //             points:0
    //            }
    //         ]      
    //     },
       
    // ]

    this._columns = [
        {
          key: 'fin',
          name: 'FIN',
          width:35
        },
        {
          key: '3',
          name: '3',
          editable: true,
          width
        },
        {
          key: '4',
          name: '4',
          editable: true,
          width
        },
        {
            key: '5',
            name: '5',
            editable: true,
            width
        },
        {
            key: '6',
            name: '6',
            editable: true,
            width
        }, {
            key: '7',
            name: '7',
            editable: true,
            width
        },
        {
            key: '8',
            name: '8',
            editable: true,
            width
        },
        {
            key: '9',
            name: '9',
            editable: true,
            width
        },
        {
            key: '10',
            name: '10',
            editable: true,
            width
        },
        {
            key: '11',
            name: '11',
            editable: true,
            width
        },
        {
            key: '13',
            name: '13',
            editable: true,
            width
        },
        {
            key: '15',
            name: '15',
            editable: true,
            width
        },
        {
            key: '17',
            name: '17',
            editable: true,
            width
        },
        {
            key: '19',
            name: '19',
            editable: true,
            width
        },
        {
            key: '21',
            name: '21',
            editable: true,
            width
        },
        {
            key: '23',
            name: '23',
            editable: true,
            width
        },
        {
            key: '25',
            name: '25',
            editable: true,
            width
        },
        {
            key: '29',
            name: '29',
            editable: true,
            width
        },
        {
            key: '33',
            name: '33',
            editable: true,
            width
        },
        {
            key: '37',
            name: '37',
            editable: true,
            width
        },
        {
            key: '41',
            name: '41',
            editable: true,
            width
        },
        {
            key: '45',
            name: '45',
            editable: true,
            width
        },
        {
            key: '49',
            name: '49',
            editable: true,
            width
        },
        {
            key: '53',
            name: '53',
            editable: true,
            width
        },
        {
            key: '57',
            name: '57',
            editable: true,
            width
        },
        {
            key: '63',
            name: '63',
            editable: true,
            width
        },
        {
            key: '69',
            name: '69',
            editable: true,
            width
        },
        {
            key: '75',
            name: '75',
            editable: true,
            width
        },
        {
            key: '81',
            name: '81',
            editable: true,
            width
        }
      ];


    this.state = { rows: this.createRows(82) }
    this.handleGridRowsUpdated = this.handleGridRowsUpdated.bind(this)
  }

  getRandomDate = (start, end) => {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toLocaleDateString();
  }

  createRows = (numberOfRows) => {
    const rows = [];
    for (let i = 2; i < numberOfRows + 1; i++) {
      rows.push({
       fin: i-1,   
       3:250,
       4:250,
       5:250
      });
    }
    return rows;
    
  }
  rowGetter = (i) => {
    return this.state.rows[i];
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
      console.log('Updating ', fromRow,toRow,updated)
    // let rows = this.state.rows.slice();

    // for (let i = fromRow; i <= toRow; i++) {
    //   let rowToUpdate = rows[i];

    //   let updatedRow = update(rowToUpdate, {$merge: updated});
    //   rows[i] = updatedRow;
    // }

    // this.setState({ rows });
  }
  render () {
    return (
        <ContentWrapper>
        <div className='pull-left col-lg-12 col-md-12'  >
      
          <Panel  style={{ maxHeight:'2560px',marginLeft:'0', marginTop:'-18px', marginBottom:'0', padding:'0px' }} md={12} lg={12}>
          <h4 style={{ color:videoblue }}> 2017-2017 Season Tier 1 Ranking Points</h4>
            <ReactDataGrid
                enableCellSelect
                columns={this._columns}
                rowGetter={this.rowGetter}
                rowsCount={this.state.rows.length}
                minHeight={2462}
                minWidth={1173}
                rowHeight={30}
                onGridRowsUpdated={this.handleGridRowsUpdated} 
            />
           </Panel>
         
      </div>
      </ContentWrapper>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ranking/RankingSettings.js